import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { routesConfig } from "./routesConfig";
import { useAppContext } from "./Lib/ContextLib";

const AccessDenied = () => (
  <div 
    className="content p-3" 
    style={{ 
      display: "flex", 
      alignItems: "center", 
      justifyContent: "center", 
      minHeight: "75vh" 
    }}
  >
    <div 
      className="card p-5 text-center shadow-lg" 
      style={{ 
        maxWidth: "500px", 
        borderRadius: "20px", 
        backgroundColor: "#162229", 
        border: "1px solid #233540",
        color: "#fff"
      }}
    >
      <div 
        className="mb-4 animate-bounce" 
        style={{ 
          fontSize: "60px", 
          color: "#ffb400" 
        }}
      >
        <i className="fas fa-shield-alt"></i>
      </div>
      <h3 className="font-weight-bold mb-3" style={{ letterSpacing: "0.5px" }}>Access Restricted</h3>
      <p className="text-muted mb-4" style={{ fontSize: "15px", lineHeight: "1.6" }}>
        Your account profile does not possess the authorized permissions to access this console page. 
        Please get in touch with your Administrator if you believe this is an error.
      </p>
      <button 
        onClick={() => window.location.href = "/dashboard"}
        className="btn font-weight-bold" 
        style={{ 
          backgroundColor: "#ffb400", 
          color: "#000", 
          borderRadius: "10px",
          padding: "10px 24px"
        }}
      >
        Back to Dashboard
      </button>
    </div>
  </div>
);

export default function Router() {
  const { accessObject } = useAppContext();

  return (
    <div>
      <Routes>
        {routesConfig.map((route, index) => {
          const Element = route.element;
          const hasAccess = route.permission 
            ? (accessObject && accessObject[route.permission] === true) 
            : true;

          return (
            <Route
              key={index}
              path={route.path}
              element={hasAccess ? <Element /> : <AccessDenied />}
            />
          );
        })}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </div>
  );
}
